import React, { useEffect, useState } from "react";

import { Controller, useForm } from "react-hook-form";

// import RatingStars from "../RatingStars/RatingStars";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Button from "@material-ui/core/Button";
import Rating from "@material-ui/lab/Rating";
import StarBorderIcon from "@material-ui/icons/StarBorder";

import { makeStyles } from "@material-ui/core/styles";
import Styles from "./FormOpinion.module.css";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexDirection: "column",

		"& > * + *": {
			marginTop: theme.spacing(1),
		},
	},
	"& .MuiRating-iconFilled": {
		color: "#ff6d75",
	},
}));

const FormOpinion = (props) => {
	const classes = useStyles();
	const { handleSubmit, setValue, control } = useForm();

	// console.log("FormOpinion Props", props);

	const onSubmit = (data) => {
		// console.log(data);

		props.formOpinionSubmit(data);
	};

	// props.data.pageData.commentEval
	// 									? props.data.pageData.commentEval
	// 									: ""
	useEffect(() => {
		console.log("FormOpinion Props", props);
		// console.log("props.data.pageData.commentEval", props.data.pageData.commentEval)

		const opinionStars = props.data.pageData.ratingEval
			? props.data.pageData.ratingEval
			: "";
		const opinionText = props.data.pageData.commentEval
			? props.data.pageData.commentEval
			: "";
		// const opinionText =
		// 	"HSJKLDAHFGJKL DHSJKLGFH JKLSDHJKLGH SJKLDH GJKLS HDJKLGH SDKLJ GH";
		// console.log("opinionText = " + opinionText);

		setValue("stars", opinionStars);
		setValue("opinion", opinionText);
	}, [setValue, props]);

	return (
		<form
			className={Styles["formOpinion"]}
			onSubmit={handleSubmit(onSubmit)}
		>
			<div className="row">
				<div className={`col-xs-12`}>
					<div className={`${Styles["score"]}`}>
						<div className={`${Styles["title"]}`}>Pontuação:</div>
						<Controller
							name="stars"
							control={control}
							defaultValue=""
							rules={{ required: { value: false } }}
							render={({ field: { onChange, name, value } }) => (
								<Rating
									name={name}
									value={value}
									onChange={onChange}
									// onChangeActive={(event, newHover) => {
									// mostrar o valor no mouse hover
									// 	console.log(newHover);
									// }}
									emptyIcon={
										<StarBorderIcon fontSize="inherit" />
									}
									style={{
										color: "var(--color-dark-blue)",
									}}
									size="large"
									precision={0.1}
									readOnly={props.data.pageData.ratingEval != "" ? true : false}
								/>
							)}
						/>
					</div>
					<Controller
						name="opinion"
						control={control}
						defaultValue=""
						rules={{ required: { value: false } }}
						render={({ field: { onChange, name, value } }) => (
							<TextareaAutosize
								name={name}
								value={value}
								onChange={onChange}
								className={`${Styles["text-area"]}`}
								aria-label="opinion"
								placeholder="Deixe a sua opinião e experiência sobre esta acção de formação"
							/>
						)}
					/>
					{!props.data.pageData.ratingEval && (
						<Button
							type="submit"
							variant="contained"
							color="primary"
							disableElevation
						>
							Guardar
						</Button>
					)}
				</div>
			</div>
		</form>
	);
};

export default FormOpinion;
